import { render, staticRenderFns } from "./ServiceEvaluation.vue?vue&type=template&id=0c226e36&lang=pug"
import script from "./ServiceEvaluation.vue?vue&type=script&lang=js"
export * from "./ServiceEvaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports